import { render, staticRenderFns } from "./QasDisplay.vue?vue&type=template&id=139c9442&scoped=true&"
import script from "./QasDisplay.vue?vue&type=script&lang=js&"
export * from "./QasDisplay.vue?vue&type=script&lang=js&"
import style0 from "./QasDisplay.vue?vue&type=style&index=0&id=139c9442&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139c9442",
  null
  
)

export default component.exports